<div
	[ngClass]="{'bg-blue-400/20': day.isToday}"
	[style.minHeight.px]="day.rowMinHeightPx"
	[style.paddingLeft.px]="hourLabelOffsetPx"
	class="flex h-full min-h-0 flex-col gap-1 xl:gap-2"
>
	@if (enabledTimes.projecthoursEnabled) {
	<div class="mt-2 flex min-h-0 flex-1 flex-row items-stretch justify-start gap-2 xl:mt-3">
		<div class="flex min-h-0 flex-1 flex-col">
			@for (row of day.projectRows | slice : 0 : day.visibleProjectRowCount; track rowIdx; let rowIdx = $index) {
			<div class="relative flex flex-1 min-h-0">
				<div
					(pointermove)="projectPointerMove.emit({ rowIndex: rowIdx, event: $event })"
					[style.width.px]="timelineWidthPx"
					class="absolute inset-y-0 left-0 flex items-center"
				>
					@for (seg of row.segments; track seg.index) {
					<div
						(pointerdown)="projectPointerDown.emit({ rowIndex: rowIdx, segIndex: seg.index, event: $event })"
						[class.segment-even]="seg.isEven"
						[class.segment-odd]="!seg.isEven"
						[class.selected]="isProjectSegmentSelected(rowIdx, seg.index)"
						[ngStyle]="getProjectSegmentSelectedStyle(rowIdx, seg.index)"
						[style.width.px]="segmentWidthPx"
						class="shrink-0 segment-projecthours h-full flex items-center cursor-pointer"
					>
						@if (seg.state === 'empty' && isProjectSelectionSingleLabel(rowIdx, seg.index)) {
						<div class="flex w-full justify-between px-0.5 text-xs segment-label pointer-events-none">
							<span>{{ segmentStartTime(seg.index) | formatDate: 'time' }}</span>
						</div>
						} @else if (seg.state === 'empty' && isProjectSelectionStartLabel(rowIdx, seg.index)) {
						<span class="text-xs segment-label pointer-events-none">
							{{ segmentStartTime(seg.index) | formatDate: 'time' }}
						</span>
						} @else if (seg.state === 'empty' && isProjectSelectionEndLabel(rowIdx, seg.index)) {
						<span class="text-xs segment-label ml-auto pointer-events-none">
							{{ segmentEndTime(seg.index) | formatDate: 'time' }}
						</span>
						}
					</div>
					} @for (fill of row.rangeFills; track fillIdx; let fillIdx = $index) {
					<div
						(click)="projectFillClick.emit({ timeRef: fill.timeRef, feedRef: fill.feedRef }); $event.stopPropagation()"
						(contextmenu)="onProjectFillContextMenu($event, fill)"
						(pointerdown)="projectPointerDown.emit({ rowIndex: rowIdx, segIndex: fill.rangeFirst, event: $event, time: fill.timeRef }); $event.stopPropagation()"
						[attr.data-fill-index]="fillIdx"
						[class.selected]="fill.classes['project'] && isProjectFillSelected(rowIdx, fill)"
						[matTooltipTemplate]="projectHourTooltip"
						[matTooltipTemplateContext]="{ refItem: fill?.timeRef ? fill.timeRef: fill.feedRef, label: fill.label }"
						[ngClass]="fill.classes"
						[ngStyle]="fill.style"
						[style.left.px]="fill.leftPx"
						[style.width.px]="fill.widthPx"
						class="segment-range-fill h-full flex items-center justify-center  cursor-pointer"
						matTooltip
					>
						@if (fill.label) {
						<span class="segment-label">{{ fill.label | truncate: fill.labelAsTooltip ? 6 : 20 }}</span>
						} @if (fill.timeRef?.recording) {
						<div class="segment-recording-indicator">
							<div class="size-3 rounded-full bg-red-500 animate-pulse"></div>
						</div>
						}
					</div>
					}
				</div>
			</div>
			}
		</div>
	</div>
	} @if (enabledTimes.workinghoursEnabled) {
	<div class="mb-2 flex min-h-0 flex-1 flex-row items-stretch justify-start gap-2 xl:mb-3">
		<div class="relative min-h-0 flex-1 min-w-0">
			<div
				(pointermove)="workingPointerMove.emit($event)"
				[style.width.px]="timelineWidthPx"
				class="absolute inset-y-0 left-0 flex items-center"
			>
				@for (seg of day.workingSegments; track seg.index) {
				<div
					(pointerdown)="(seg.isEmpty && (canCreateWorkinghours.value)) ? workingPointerDown.emit({ segIndex: seg.index, event: $event }) : null"
					[class.segment-even]="seg.isEven"
					[class.segment-odd]="!seg.isEven"
					[class.selected]="isWorkingSegmentSelected(seg.index)"
					[ngClass]="{ 'cursor-pointer': (canCreateWorkinghours.value$ | async) }"
					[ngStyle]="getWorkingSegmentSelectedStyle(seg.index)"
					[style.width.px]="segmentWidthPx"
					class="shrink-0 segment-workinghours h-full flex items-center"
				>
					@if (seg.isEmpty && isWorkingSelectionSingleLabel(seg.index)) {
					<div class="flex w-full justify-between px-0.5 text-xs segment-label pointer-events-none">
						<span>{{ segmentStartTime(seg.index) | formatDate: 'time' }}</span>
					</div>
					} @else if (seg.isEmpty && isWorkingSelectionStartLabel(seg.index)) {
					<span class="text-xs segment-label pointer-events-none">
						{{ segmentStartTime(seg.index) | formatDate: 'time' }}
					</span>
					} @else if (seg.isEmpty && isWorkingSelectionEndLabel(seg.index)) {
					<span class="text-xs segment-label ml-auto pointer-events-none">
						{{ segmentEndTime(seg.index) | formatDate: 'time' }}
					</span>
					}
				</div>
				} @for (fill of day.workingRangeFills; track fillIdx; let fillIdx = $index) {
				<div
					(click)="fill.isSuggestion ? onSuggestionFillClick(fill, $event): workingFillClick.emit({ fill })"
					(pointerdown)="(!fill.isSuggestion && (canUpdateWorkinghours.value)) ? workingPointerDown.emit({ segIndex: fill.rangeFirst, event: $event, comegoRef: fill.comegoRef, fill }) : null; !fill.isSuggestion ? $event.stopPropagation() : null"
					[class.cursor-pointer]=" fill.isSuggestion ? (canCreateWorkinghours.value$ | async ) : canUpdateWorkinghours.value"
					[class.justify-center]="!fill.isSuggestion"
					[class.justify-end]="fill.isSuggestion"
					[class.selected]="fill.classes['work'] && isWorkingFillSelected(fill)"
					[matTooltipDisabled]="fill.isSuggestion || !(fill.classes['work'] || fill.classes['absence'] || fill.classes['break'])"
					[matTooltipTemplate]="workingHourTooltip"
					[matTooltipTemplateContext]="{ refItem: fill.comegoRef, label: fill.labelKey }"
					[ngClass]="fill.classes"
					[ngStyle]="fill.style"
					[style.left.px]="fill.leftPx"
					[style.width.px]="fill.widthPx"
					class="segment-range-fill h-full flex items-center"
					matTooltip
				>
					@if (fill.isSuggestion) {
					<mat-icon class="suggestion-check-icon mr-4">check</mat-icon>
					} @if (fill.labelKey && !fill.isSuggestion) {
					<span class="segment-label">{{
						fill.labelKey | translate | truncate: fill.labelAsTooltip ? 6 : 20
					}}</span>
					} @if (fill.labelKey && fill.isSuggestion) {
					<span class="segment-label segment-label-suggestion">{{
						fill.labelKey | translate | truncate: fill.labelAsTooltip ? 6 : 20
					}}</span>
					} @if (fill.comegoRef?.recording) {
					<div class="segment-recording-indicator">
						<div class="size-3 rounded-full bg-red-500 animate-pulse"></div>
					</div>
					}
				</div>
				}
			</div>
		</div>
	</div>
	}
</div>

<ng-template
	#workingHourTooltip
	let-label="label"
	let-refItem="refItem"
>
	<div class="px-1 py-1.5">
		<ng-container>
			<div class="flex flex-col">
				<div>{{ label | translate  | truncate: 40 }}</div>
				<div class="flex items-center space-x-0.5">
					<span class="mat-hint italic">{{ refItem.timeDiff | parseMsAsDuration }}</span>
					<ng-container *ngIf="refItem.inputMode !== 'duration'">
						<span>-</span>
						<span>({{ refItem.start | formatDate: 'time' }}- {{ refItem.end | formatDate: 'time' }})</span>
					</ng-container>
				</div>
				<div *ngIf="refItem.billable">{{ 'Billable_Alt' | translate }}</div>
			</div>
		</ng-container>
	</div>
</ng-template>
<ng-template
	#projectHourTooltip
	let-label="label"
	let-refItem="refItem"
>
	<div class="px-1 py-1.5">
		<ng-container>
			<div class="flex flex-col">
				<div>{{ lable | truncate: 40 }}</div>
				@if (refItem?.project) {
				<div class="flex flex-row items-center justify-start gap-1">
					<span>{{ refItem.project | defaultEntityTranslate: 'project' : 'project.none' }}</span>
					<ng-container *ngIf="refItem.task as task">
						<div class="mat-bg-30 h-1 w-1 rounded-full"></div>
						<span>{{ task.name | truncate: 25 }}</span>
					</ng-container>
				</div>
				}
				<div class="flex items-center space-x-0.5">
					<span class="mat-hint italic">
						{{
							refItem?.timeDiff
							? (refItem.timeDiff | parseMsAsDuration)
							: (refItem.start | dfnsParseIso | dfnsDifferenceInSeconds:(refItem.end | dfnsParseIso) | parseMsAsDuration)
						}}
					</span>
					<ng-container *ngIf="refItem.inputMode !== 'duration'">
						<span>-</span>
						<span>({{ refItem.start | formatDate: 'time' }}- {{ refItem.end | formatDate: 'time' }})</span>
					</ng-container>
				</div>
				<div *ngIf="refItem.billable">{{ 'Billable_Alt' | translate }}</div>
			</div>
		</ng-container>
	</div>
</ng-template>

<mat-menu #eventContextMenu="matMenu">
	<ng-template
		let-time="time"
		matMenuContent
	>
		<button
			(click)="projectFillContextEdit.emit(time)"
			[disabled]="isProjectFillContextDisabled(time)"
			mat-menu-item
		>
			{{ 'timer.calendar.eventContext.edit' | translate }}
		</button>
		<button
			(click)="projectFillContextDuplicate.emit(time)"
			[disabled]="isProjectFillContextDisabled(time)"
			mat-menu-item
		>
			{{ 'timer.calendar.eventContext.duplicate' | translate }}
		</button>
		<button
			(click)="projectFillContextRemove.emit(time)"
			[disabled]="isProjectFillContextDisabled(time)"
			class="text-warn"
			mat-menu-item
		>
			{{ 'timer.calendar.eventContext.remove' | translate }}
		</button>
	</ng-template>
</mat-menu>
<div
	[matMenuTriggerFor]="eventContextMenu"
	[style.left]="contextMenuPosition.x"
	[style.top]="contextMenuPosition.y"
	#eventContextTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
